import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import { loadCommonFoundationsLessonCards } from '../../services/dataApi';
import LessonFlow from '../../components/LessonFlow';

// Interactive lesson version of the Common Foundations reference page —
// an additional entry point (the reference view stays unchanged).
export default function CommonFoundationsLessonPage() {
  const { t } = useTranslation();
  const { languagePrefs } = useAuth();
  const targetCode = languagePrefs?.targetLanguage || '';

  const loader = useCallback(
    () => loadCommonFoundationsLessonCards(targetCode),
    [targetCode],
  );

  return (
    <LessonFlow
      loader={loader}
      loaderDeps={[targetCode]}
      backTo="/learn/common-foundations"
      backLabel={t('tools.commonFoundations')}
    />
  );
}
